module.exports = __webpack_public_path__ + "static/img/solve2.1d23ed3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/solve2.png
// module id = VaTI
// module chunks = 1